var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1087,
    height: 884,
    viewBox: "0 0 1087 884",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326 508C362.451 508 392 478.451 392 442C392 405.549 362.451 376 326 376C289.549 376 260 405.549 260 442C260 478.451 289.549 508 326 508Z",
    fill: "#39D377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 484C349.644 484 368 465.644 368 443C368 420.356 349.644 402 327 402C304.356 402 286 420.356 286 443C286 465.644 304.356 484 327 484Z",
    fill: "#39D377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 461C336.941 461 345 452.941 345 443C345 433.059 336.941 425 327 425C317.059 425 309 433.059 309 443C309 452.941 317.059 461 327 461Z",
    fill: "#39D377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 441.5H336.5",
    stroke: "#39D377",
    strokeWidth: 4.2,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300 441.842C300 441.842 311.715 441.842 333.358 441.842C355 441.842 388 412.206 388 359.498C388 306.791 388 187.408 388 114.125C388 40.8418 409.818 3 465.909 3C522 3 527.731 3 527.731 3",
    stroke: "#39D377",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300 442C300 442 311.715 442 333.358 442C355 442 388 471.636 388 524.343C388 577.051 388 696.434 388 769.717C388 843 409.818 880.842 465.909 880.842C522 880.842 527.731 880.842 527.731 880.842",
    stroke: "#39D377",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M527 3L767 2",
    stroke: "#39D377",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337 442L767 441",
    stroke: "#39D377",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M527 882L767 881",
    stroke: "#39D377",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M953 3L1085 2",
    stroke: "#39D377",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M953 442L1085 441",
    stroke: "#39D377",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M953 882L1085 881",
    stroke: "#39D377",
    strokeWidth: 3,
    strokeLinecap: "square"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteflow);
export default __webpack_public_path__ + "static/media/noteflow.61d94ae35c2c6cc0267780b8677d1c7a.svg";
export { ForwardRef as ReactComponent };